import React  from "react";
import { useParams } from 'react-router-dom';
import EmployeeForm from "./components/EmployeeForm";

const ViewEmployee = () => {
	const { accountId, employeeId } = useParams();
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<EmployeeForm recordId={employeeId} accountId={accountId} mode="view"/>
	      </div>
	    </div>
    );
};

export default ViewEmployee;